"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _TableFooter = _interopRequireDefault(require("@material-ui/core/TableFooter"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function SttTableFooter(props) {
  return /*#__PURE__*/_react["default"].createElement(_TableFooter["default"], props);
}
var _default = SttTableFooter;
exports["default"] = _default;